<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col
            v-for="(item, index) in leaveStatList"
            :key="`display-card-${index}`"
            cols="12"
            sm="6"
            lg="3"
          >
            <display-card
              :title="item.title"
              :subTitle="item.subTitle"
              :footer="item.footer"
              :icon="item.icon"
              :leave-day-name="item.leaveDayName"
              :leave-amount="item.leaveAmount"
              :leave-day-all="item.leaveDayAll"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <leave-calendar />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import LeaveCalendar from '@/components/leave/LeaveCalendar'

export default {
  components: {
    LeaveCalendar
  },

  data() {
    return {
      empInfo: {},
      leaveStatList: []
    }
  },

  computed: {
    title() {
      const txt = 'การลาราชการปีงบประมาณ ' + this.$nowBudgetYear + ' '
      let name = ''

      if (this.$guid === this.$guid_self) {
        name = this.$username
      } else {
        name = this.empInfo[`employeeName${this.$lang}`] || ''
      }
      return txt + name
    }
  },

  async mounted() {
    if (this.$guid !== this.$guid_self) {
      this.empInfo = (await this.apiGetEmpName()) || {}
    }
    await this.setLeaveStat()
  },

  methods: {
    async setLeaveStat() {
      const res = await this.apiGetLeaveStat()
      if (res) {
        this.leaveStatList = res.map(item => {
          return {
            title: item.leaveTypeFullNameTha,
            subTitle: item.leaveAmount + ' ' + item.leaveDayName,
            footer: `สิทธิ์ลา ${item.leaveDayAll}
            ${item.leaveDayName}
            <br />เหลือ <span class="error--text">
            ${parseFloat(item.leaveDayAll) - parseFloat(item.leaveAmount)}
            </span>
            ${item.leaveDayName}`,
            leaveDayName: item.leaveDayName,
            leaveAmount: item.leaveAmount,
            leaveDayAll: item.leaveDayAll,
            icon: item.leaveTypeIcon
          }
        })
      }
    },

    async apiGetEmpName() {
      try {
        const res = await this.$store.dispatch('user/getInfo', this.$guid)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetLeaveStat() {
      try {
        const res = await this.$store.dispatch('leave/getLeaveStat', this.$guid)
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
